export const iconFontAwesomeNatureMound = (
	<i className="fa-solid fa-mound"></i>
);
